import { render, staticRenderFns } from "./BtnMed.vue?vue&type=template&id=0804fec0&"
import script from "./BtnMed.vue?vue&type=script&lang=js&"
export * from "./BtnMed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports